require('./cardRewards.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classnames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
// @ components
const { CardRewardsTableRow } = require('./cardRewardsTableRow/cardRewardsTableRow');
// @ actions
const { requestRewards, resetCardRewards } = require('actions/cardRewards');
//@constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class CardRewards extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const {
            cardId,
            requestRewards,
        } = this.props;

        requestRewards(cardId);
    }

    componentWillUnmount() {
        const { resetCardRewards } = this.props;

        resetCardRewards();
    }

    buildContent(immCardRewards) {
        if (immCardRewards.get('error')) {
            return this.buildEmptyState('cardRewards-cardRewards_emptyStateErrorMessage', 'nointernet-banking');
        }

        if (immCardRewards.get('loading')) {
            return <LoadingSection />;
        }

        if (immCardRewards.get('byOrder').size === 0) {
            return this.buildEmptyState('cardRewards-cardRewards_noResults', 'search-banking');
        }

        return this.buildTable();
    }

    buildEmptyState(messageKey, iconType) {
        return (
            <EmptyState
                iconType={iconType}
                primaryText={formatText(messageKey)}
            />
        );
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true} className="card-rewards__table-header-row-line">
                        <OKTableCell
                            asHeader={true}
                            className="card-rewards__table-header-cell-line"
                            colSpan={2}
                        />
                    </OKTableRow>
                </thead>
            );
        } else {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true} className="card-rewards__table-cells-header">
                            <FormattedText value="cardRewards-cardRewards_date" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="card-rewards__table-cells-header">
                            <FormattedText value="cardRewards-cardRewards_description" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="card-rewards__table-cells-header">
                            <FormattedText value="cardRewards-cardRewards_paymentAccount" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="card-rewards__table-cells-header--right">
                            <FormattedText value="cardRewards-cardRewards_amount" format="uppercase" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            );
        }

        return tableHead;
    }

    buildTable() {
        const {
            immCardRewards,
            immScreen,
        } = this.props;

        const tableHead = this.buildTableHead();
        const columns = immScreen.get('isMobile') ? 2 : 4; 

        return (
            <LastMovementsTable
                columnsCount={columns}
                currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                groupByDate={false}
                id="card-rewards"
                immTransactionsById={immCardRewards.get('byId')}
                immTransactionsByOrder={immCardRewards.get('byOrder')}
                isExpandable={false}
                language={language}
                rowComponent={CardRewardsTableRow}
            >
                {tableHead}
            </LastMovementsTable>
        );
    }

    render() {
        const { immCardRewards } = this.props;
        const headerTitle = formatText('cardRewards-cardRewards_paymentsReceived');
        const headerClasses = classnames('card-rewards__title');

        return (
            <section>
                <header className={headerClasses}>
                    <OKBoxTitle value={headerTitle} inline={true} />
                </header>
                {this.buildContent(immCardRewards)}
            </section>
        );
    }
}

CardRewards.propTypes = {
    accountId: PropTypes.string.isRequired,
    cardId: PropTypes.string.isRequired,
    immCardRewards: PropTypes.object,
    immScreen: PropTypes.object,
    requestRewards: PropTypes.func.isRequired,
    resetCardRewards: PropTypes.func.isRequired,
};

module.exports.constructor = CardRewards;
module.exports.CardRewards = connect(
    state => ({
        immCardRewards: state.cardRewards,
        immScreen: state.screen,
    }),
    {
        requestRewards,
        resetCardRewards,
    }
)(CardRewards);
